const s = {
  name: "Ratio1x1",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36,4h-6v2h4v4h2V4z"/>
		<path class="st0" d="M6,30v4h4v2H4v-6H6z"/>
		<path class="st0" d="M40,0H0v40h40V0z M38,2v36H2V2H38z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Ratio1x1
};
